import React from 'react';
import { motion } from 'framer-motion';
import Marquee from '../Marquee';
import SpacedHeading from '../SpacedHeading';
import { awards, PROFESSIONAL_IMAGE } from '../../mock';

export default function Awards() {
  return (
    <section id="awards" className="relative bg-[var(--bg)] pt-20 md:pt-28 pb-0">
      <Marquee items={["TRAJETÓRIA PROFISSIONAL", "PROJETOS", "DESIGN", "EXPERIÊNCIA"]} speed={8} className="border-y border-[var(--border)]" />


      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-20 md:mt-28">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-20 md:mb-28">
          <SpacedHeading className="text-4xl md:text-7xl lg:text-8xl">Trajetória Profissional</SpacedHeading>
          <div className="text-sm tracking-[0.3em] text-white/60">2017 - 2025</div>
        </div>

        <div className="grid md:grid-cols-12 gap-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="md:col-span-5 relative rounded-[var(--card-radius)] overflow-hidden aspect-[4/5] md:aspect-auto md:h-full min-h-[420px]"
          >

            <img src={PROFESSIONAL_IMAGE} alt="Awards" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="text-xs tracking-[0.3em] text-[var(--accent)] mb-2 uppercase">Design Estratégico</p>
              <p className="font-display text-2xl md:text-3xl">Soluções visuais que transformam marcas em resultados reais.</p>
            </div>

          </motion.div>

          <div className="md:col-span-7 grid sm:grid-cols-2 gap-5">
            {awards.map((a, i) => (
              <motion.div
                key={a.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="rounded-[var(--card-radius)] border border-[var(--border)] bg-[var(--card)] p-8 hover:border-[var(--accent)]/50 transition-all group flex flex-col h-full"
              >
                <span className="text-[10px] tracking-[0.3em] text-[var(--accent)] font-semibold mb-6">
                  {a.date}
                </span>
                
                <h4 className="font-display text-2xl md:text-3xl leading-tight mb-2 group-hover:text-[var(--accent)] transition-colors">
                  {a.title}
                </h4>
                
                <p className="text-sm tracking-wide text-white/80 mb-6 font-medium">
                  {a.role}
                </p>

                <p className="text-sm text-[var(--muted)] leading-relaxed mt-auto">
                  {a.desc}
                </p>

              </motion.div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
